import axiosPost from '../axiosPost';
import { EmpleadoEdit, MerchantUsuarioType, UserCredentialsType } from '../../../types/types';
import { AxiosPostBody } from '../../../types/AxiosPost';

export const MerchantEmpleadoUpd = async (arg: UserCredentialsType, data: EmpleadoEdit) => {
    const body: AxiosPostBody = {
        "service": "MerchantEmpleadoUpd",
        "params": {
            merchantUsuarioUsuarioId: data.usuarioEmpleadoId,
            merchantUsuarioRolId: data.rolId,
            merchantId: data.merchantId,
            merchantUsuarioSucursalId: data.merchantSucursalId,
            merchantUsuarioFecha: data.merchantUsuarioFecha,
        }
    }

    const result = await axiosPost<MerchantUsuarioType>('Y', body, arg);
        if(result?.status?.code === 0) {
            return [result.status]
        } else {
            return result.result;
        }
}